import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { ICcyPairLookupService } from "../../../../lookup/model/ICcyPairLookupService";

// String types that are sortable as an Int32 in C++ module
export class NotificationTransactionHelper {
  constructor(private _ccyPairLookup: ICcyPairLookupService) {}

  adapt(row: any): string {
    return this.retrieveData(row);
  }

  retrieveData(item: any): string {
    return this.perform(item);
  }

  perform(item: any): string {
    let order = item["orderData"];
    let deal = item["deal"];
    let result: string = "";
    if (order) {
      if (
        item["reason"] !== null &&
        item["reason"] !== undefined &&
        (item["reason"] === CubiqTS.DIReason.CREDIT_REJECT_FAIL ||
          item["reason"] === CubiqTS.DIReason.CREDIT_EXPIRY_FAIL ||
          item["reason"] === CubiqTS.DIReason.CREDIT_CANCEL_FAIL ||
          item["reason"] === CubiqTS.DIReason.CREDIT_REJECT_TIMEOUT ||
          item["reason"] === CubiqTS.DIReason.CREDIT_EXPIRY_TIMEOUT ||
          item["reason"] === CubiqTS.DIReason.CREDIT_CANCEL_TIMEOUT ||
          item["reason"] === CubiqTS.DIReason.ENTRY_CREDIT_FAIL ||
          item["reason"] === CubiqTS.DIReason.MODIFY_CREDIT_FAIL ||
          item["reason"] === CubiqTS.DIReason.MODIFY_CREDIT_PROXIMITY_FAIL ||
          item["reason"] === CubiqTS.DIReason.ENTRY_CREDIT_PROXIMITY_FAIL ||
          item["reason"] === CubiqTS.DIReason.DAILY_REVAL_CREDIT_FAIL ||
          item["reason"] === CubiqTS.DIReason.PROXIMITY_REVAL_CREDIT_FAIL ||
          item["reason"] === CubiqTS.DIReason.FORCE_TO_DI)
      ) {
        // Dealt Amount
        let orderQty = order["orderQty"];

        if (orderQty && orderQty instanceof CubiqTS.BigNumber) {
          result += orderQty.dividedBy(1000000).toFixed(2).toString() + "m ";
        }
        // Dealt currency
        let dealtCcy = order["fixedCode"];
        if (dealtCcy && typeof dealtCcy === "string") {
          result += dealtCcy + " ";
        }

        result += this.getRequestRate(item);
      } else if (
        item["reason"] !== null &&
        item["reason"] !== undefined &&
        item["reason"] === CubiqTS.DIReason.FILL_CREDIT_FAIL
      ) {
        // Dealt Amount
        let orderQty = order["orderQty"];
        if (deal) {
          orderQty = deal["amt1"];
        }
        if (orderQty && orderQty instanceof CubiqTS.BigNumber) {
          result += orderQty.dividedBy(1000000).toFixed(2).toString() + "m ";
        }
        // Dealt currency
        let dealtCcy = order["fixedCode"];
        if (dealtCcy && typeof dealtCcy === "string") {
          result += dealtCcy + " ";
        }
        result += this.getRequestRate(item);
      }
      return result;
    }
  }

  /* Rate functions START */

  getValue(order: any, columnProperty: string): CubiqTS.BigNumber {
    if (order[columnProperty] != undefined && order[columnProperty] != null)
      return new CubiqTS.BigNumber(order[columnProperty]);
    return null;
  }

  getFormattedValue(order: any, rate: CubiqTS.BigNumber): string {
    let minPrecision: number = this.getMinPrecision(order);
    let currentDecs: number = rate.decimalPlaces();
    if (currentDecs < minPrecision) {
      return rate.toFixed(minPrecision);
    }
    return rate.toFixed(currentDecs);
  }

  getMinPrecision(order: any): number {
    let ccyPair = this.getCcyPair(order);
    if (ccyPair) {
      if (order["isInvert"]) {
        return ccyPair.spotInvertDecimalsQty;
      } else {
        return ccyPair.pipsQty;
      }
    }
    return 0;
  }
  private getCcyPair(order: any): any {
    if (this._ccyPairLookup) {
      return this._ccyPairLookup.getCcyPair(order["baseCcyCd"], order["nonBaseCcyCd"]);
    }
    return null;
  }

  public getClientIntent(clientIntent: number): string {
    let intent: string = "";
    if (clientIntent === CubiqTS.OrderIntent.BUY) {
      intent = "Buy ";
    } else if (clientIntent === CubiqTS.OrderIntent.SELL) {
      intent = "Sell ";
    }
    return intent;
  }

  public getRequestRate(item: any): string {
    let order = item["orderData"];
    let deal = item["deal"];
    let rate: string = "";
    if (order) {
      let requestRate = this.getValue(order, "requestRt");
      if (requestRate) {
        rate = this.getFormattedValue(order, requestRate) + " ";
      }
    } else if (
      item["reason"] !== null &&
      item["reason"] !== undefined &&
      item["reason"] === CubiqTS.DIReason.FILL_CREDIT_FAIL
    ) {
      let allInClientRate;

      if (deal) {
        allInClientRate = this.getValue(deal, "allInClientRate");
      }

      if (allInClientRate) {
        rate = this.getFormattedValue(order, allInClientRate) + " ";
      }
    }
    return rate;
  }
}
